'use client'

import { api } from '@/shared/services/api'
import type { Data } from '@/shared/types/data'

export type BootstrapPayload = Data

const BOOTSTRAP_PATH = '/user/gamification/data'

export async function fetchBootstrap(): Promise<BootstrapPayload> {
  const { data } = await api.get<{ record: BootstrapPayload }>(BOOTSTRAP_PATH)
  if (!data?.record) throw new Error('Bootstrap response missing record')
  return data.record
}

export function bootstrapQueryOptions(userId: string) {
  return {
    queryKey: ['bootstrap', userId] as const,
    queryFn: fetchBootstrap,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 2,
    retryDelay: (attempt: number) => Math.min(500 * 2 ** attempt, 2000),
    refetchOnWindowFocus: false,
    refetchOnReconnect: true
  } as const
}
